import { useState, useEffect } from 'react'
import { boardsService } from '../services/boards'
import { useAuth } from './useAuth'

const POLL_INTERVAL_MS = 30_000

export function usePendingActionsCount(): number {
  const [count, setCount] = useState(0)
  const { user } = useAuth()
  const role = user?.profile?.role

  // Só ativa polling para gestores e coordenadores de escola — operadores retornam 0
  // do backend. is_staff (admin Eleve.IA) recebe role='manager' por padrão no backend
  // mesmo sem escola vinculada, mas não tem esse badge no sidebar — não deve pollar.
  const isEligible = (role === 'manager' || role === 'coordinator') && !user?.is_staff

  useEffect(() => {
    if (!isEligible) return

    let cancelled = false

    const fetchCount = async () => {
      try {
        const { count: c } = await boardsService.getPendingActionsCount()
        if (!cancelled) setCount(c)
      } catch {
        // silencioso — badge não é crítico
      }
    }

    fetchCount()
    // Aba em segundo plano não consulta — cada aba aberta gastava o limite de
    // requisições da API do usuário à toa.
    const interval = setInterval(() => { if (!document.hidden) fetchCount() }, POLL_INTERVAL_MS)
    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [isEligible])

  return count
}
